import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { RestTmtService } from '../../rest-tmt.service';
import { HttpClient } from '@angular/common/http';

/**ToDo Documentazione */
@Component({
  selector: 'app-language-switcher',
  styleUrls: ['./language-switcher.component.scss'],
  templateUrl: './language-switcher.component.html'
})
export class LanguageSwitcherComponent {

  public languageNames: {[index: string]: string} = {
    en: 'English',
    fr: 'Français',
    it: 'Italiano',
    nl: 'Dutch'
  };

  public languages: string[];
  public selectedLanguage: string;
  public consolidator = this.service.getClient().consolidator;

  constructor(public translateService: TranslateService, private service: RestTmtService, private http: HttpClient, private readonly logger: NGXLogger) {
    this.languages = translateService.getLangs();
    this.selectedLanguage = translateService.currentLang;
  }

  public updateLanguage() {
    this.logger.info(`Cambio la lingua in ${this.selectedLanguage}`);
    localStorage.setItem('selectedLanguage', this.selectedLanguage);

    this.translateService.use(this.selectedLanguage).subscribe(() => {
      const customTranslationsUrl = `assets/custom/${this.service.getClient().consolidator}/i18n/custom.${this.selectedLanguage}.json`;
      this.http.get(customTranslationsUrl).subscribe((customTranslations: any) => {
        if(customTranslations) {
          this.translateService.setTranslation(this.selectedLanguage, customTranslations, true);
        }
      });
    });
  }
}
